<template>
  <div>
    <div class="flex w-full vx-row no-gutter" style="height: 60px" :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`">
      <div class="vx-col sm:w-1/3 flex items-center flex-col">
        <img :src="`/assets/images/pages/login_${appFilename}.png`" alt="" style="height: 60px" />
      </div>
    </div>
    <div class="flex w-full bg-img vx-row no-gutter" style="background: #F3F3F7">
      <div class="flex w-full justify-center">
        <div class="vx-col sm:w-1/4 m-4 flex items-center flex-col">
          <div class="text-2xl font-bold text-center mt-6 mb-8">
            Crie sua conta {{ appName }}
          </div>
          <div>
            <form @submit="nextSubmit">
              <vs-input
                v-validate="'required|email'"
                data-vv-validate-on="blur"
                name="email"
                type="email"
                label-placeholder="E-mail"
                placeholder="E-mail"
                v-model.trim="email"
                class="w-full mt-6"
                autocomplete="username"
              />
              <span class="text-danger text-sm">{{ errors.first('email') }}</span>

              <vs-button class="mt-6 mb-6 w-full p-4" @click="next"><h3 class="text-white">CONTINUAR</h3></vs-button>

              <div>Ao clicar em "CONTINUAR", você está aceitando os <a :href="appLinkTermos" target="_blank">Termos de Uso</a> e a <a :href="appLinkPoliticaPrivacidade" target="_blank">Política de Privacidade</a>.</div>
              <div class="my-4">
                Já tem uma conta {{ appName }}?
                <router-link to="/pages/login?returnTo=%2Fpages%2Fsign-up%2Fplans" class="mt-6">ENTRAR</router-link>
              </div>

              <button type="submit" style="display: none"></button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      affiliate: "",
      appLinkTermos: process.env.VUE_APP_LINK_TERMOS_USO,
      appLinkPoliticaPrivacidade: process.env.VUE_APP_LINK_POLITICA_PRIVACIDADE,
      appName: process.env.VUE_APP_NAME,
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    if (this.$route.query.aff) {
      localStorage.setItem('aff', this.$route.query.aff)
    }

    this.email = localStorage.getItem('sign-up-email')
  },
  computed: {},
  methods: {
    next() {
      this.$api
          .post("/api/v1/auth/sign-up", {
            email: this.email
          })
          .then(() => {
            localStorage.setItem('sign-up-email', this.email)
            this.$router.push('/pages/sign-up/plans');
          })
          .catch(error => {
            this.$vs.notify({
              time: 6000,
              text: error.response.data.errors.join("<br>"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          });
    },
    nextSubmit(e) {
      this.next();
      e.preventDefault();
    }
  }
};
</script>
<style>
body {
  background: #F3F3F7;
}
</style>
